export default __webpack_public_path__ + "static/media/Ancient Serpent Staff.a922bdb6.jpg";